"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const Validations_1 = require("../../functions/Validations");
const moment_1 = __importDefault(require("moment"));
class Form extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isValid: true,
        };
        this.erros = [];
        this.clear = () => {
            this.erros = [];
            this.setState({ isValid: true });
        };
        this.validate = () => {
            this.erros = [];
            if (this.props.children.length > 0)
                this.validarRecursivo(this.props.children);
            const isValid = this.erros.length === 0;
            this.setState({
                isValid,
            });
            return isValid;
        };
        this.validarRecursivo = (children) => {
            if (children.forEach) {
                children.forEach((campo) => {
                    if (this.filtroCampos(campo)) {
                        // Valida cada campo
                        if (campo.props.required) {
                            if (typeof campo.props.value === "undefined" ||
                                campo.props.value === "" ||
                                campo.props.value === 0)
                                this.erros.push(`Campo "${campo.props.title || campo.props.placeholder}" obrigatório.`);
                        }
                        /*
                                      Essa série de ifs existe mais para organização.
                                      Como o Combo não tem props como "tipo" os ifs
                                      internos do validarCampoTexto não são executados.
                                      Em tese.
                                  */
                        if (campo.type === __1.Input) {
                            this.validarCampoTexto(campo);
                        }
                    }
                    else {
                        if (campo.props &&
                            campo.props.children &&
                            campo.props.children.length > 0)
                            this.validarRecursivo(campo.props.children);
                    }
                });
            }
        };
        this.validarCampoTexto = (campo) => {
            // Validações específicas de CampoTexto vão aqui
            if (campo.props.type === 'email' &&
                Validations_1.Validations.email(campo.props.value))
                this.erros.push("E-mail inválido.");
            if (campo.props.type === 'date') {
                const date = moment_1.default(campo.props.value, "DD/MM/YYYY", true);
                if (!date.isValid())
                    this.erros.push(`Campo "${campo.props.title || campo.props.placeholder}" inválido.`);
            }
            var valorSemMascara = null;
            if (campo.props.value !== undefined &&
                campo.props.type !== 'number' &&
                campo.props.type !== 'money' &&
                campo.props.type !== 'percent') {
                valorSemMascara = campo.props.value.split("_").join("");
            }
            if (campo.props.min && valorSemMascara.length < campo.props.min)
                this.erros.push(`Campo "${campo.props.title || campo.props.placeholder}" inválido.`);
        };
        this.filtroCampos = (campo) => campo.type === __1.Input || campo.type === __1.ComboBox;
    }
    render() {
        const { children } = this.props;
        const childrenWithProps = react_1.default.Children.map(children, (child) => {
            if (child && child.type === __1.Alert && child.props.formAlert)
                return react_1.default.cloneElement(child, { children: this.erros.join("<br/>") });
            else
                return child;
        });
        return react_1.default.createElement("form", null, childrenWithProps);
    }
}
exports.Form = Form;
